import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from './user.service';
import { DatePipe } from '@angular/common';

@Injectable()
export class CommonSerivce {


  errors: string;
  LoginApiPath: string = "api/BcpJwtAuth/";

  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private userService: UserService) {
  }



  getAccessRightByProcess(processName: string) {
    var accessRight = "NA";
    accessRight = sessionStorage.getItem(processName);

    return accessRight;

  }



  //not use, replaced by getHttpOption, as no need to set the bearer token
  getHttpHeader() {


    var headers = new HttpHeaders();
    /*
        let validFor = JSON.parse(sessionStorage.getItem('validFor'));
        let tokenExpiration = JSON.parse(sessionStorage.getItem('tokenExpiration'));
        let longTokenExpiration = JSON.parse(sessionStorage.getItem('longTokenExpiration'));

        let utcDate = new Date();
        let authToken = sessionStorage.getItem('auth_token');
        let newExpiration = new Date(utcDate.getTime() + validFor * 1000);

        console.log("token get from commom " + authToken);


        if (utcDate.toJSON().slice(0, 19) >= tokenExpiration.slice(0, 19)
            && utcDate.toJSON().slice(0, 19) <= longTokenExpiration.slice(0, 19)) {

            //renew expired token
            authToken = sessionStorage.getItem('auth_token_long');

          this.userService.renewToken().add(result => {
            if (result) {
              //this.router.navigate(['/login']);
              console.log("testing");
            }
          });


        } else {
            sessionStorage.setItem('longTokenExpiration', JSON.stringify(newExpiration.toJSON()));
        }


        headers.append('Content-Type', 'application/json; charset=utf-8');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        headers.append('Authorization', `Bearer ${authToken}`);
        */
    return headers;
  }

  getHttpOptions() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
      , 'Cache-Control': 'no-cache'
      , 'Pragma': 'no-cache'
      //, 'Authorization': `Bearer ${authToken}`
    });

    let options = {
      headers
    };

    return options;
  }


  createHttpHeaders(token: string): { headers: HttpHeaders } {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Authorization': `Bearer ${token}`
    });
    let options = { headers };
    return options;

  }


  getHttpOptionsAtt(returnType?: string) {

    //let validFor = JSON.parse(sessionStorage.getItem('validFor'));
    //let tokenExpiration = JSON.parse(sessionStorage.getItem('tokenExpiration'));
    //let longTokenExpiration = JSON.parse(sessionStorage.getItem('longTokenExpiration'));

    //let utcDate = new Date();
    //let authToken = sessionStorage.getItem('auth_token');
    //let newExpiration = new Date(utcDate.getTime() + validFor * 1000);

    ////console.log("token get from commom " + authToken);

    //if (utcDate.toJSON().slice(0, 19) >= tokenExpiration.slice(0, 19)
    //  && utcDate.toJSON().slice(0, 19) <= longTokenExpiration.slice(0, 19)) {

    //  //renew expired token
    //  authToken = sessionStorage.getItem('auth_token_long');

    //  //this.userService.renewToken().add(result => {
    //  //  if (result) {
    //  //    //this.router.navigate(['/login']);
    //  //    console.log("renew token");
    //  //  }
    //  //});


    //} else {
    //  sessionStorage.setItem('longTokenExpiration', JSON.stringify(newExpiration.toJSON()));
    //}

    let headers = new HttpHeaders({
      //'Content-Type': 'application/json; charset=utf-8'
      'Cache-Control': 'no-cache'
      , 'Pragma': 'no-cache'
      //, 'Authorization': `Bearer ${authToken}`
      //, 'Accept': 'application / octet - stream' 
    });
    let options = {};

    if (returnType === "blob") {
      options = {
        headers, responseType: 'blob' as 'blob', observe: 'response'
      };
    } else {
      options = {
        headers, responseType: 'json' as 'json'
      };
    }
    return options;
  }

  getFilenameFromHttpResponse(contentDisposition) {
    var filename = "";
    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (contentDisposition) {
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].trim();
      }
    }
    filename = filename.replace(/"/g, "");
    return filename;
  }

  getEnvironment() {
    var result = "";
    try {
      result = JSON.parse(sessionStorage.getItem('environment'));
    } catch (e) {

    }
    return result;
  }

  getAttachmentTarget() {
    var result = "";
    try {
      result = JSON.parse(sessionStorage.getItem('attachmentTarget'));
    } catch (e) {

    }
    return result;
  }

  getLoginStatus() {
    var loginStatus = "";
    var result: boolean;

    try {
      loginStatus = JSON.parse(sessionStorage.getItem('isLoggedIn'));
      if (loginStatus == "true") {
        result = true;
      } else {
        result = false;
      }
    } catch (e) {

    }
    return result;
  }

  getCurrentDomainId() {
    var currentDomainId = "";
    try {
      currentDomainId = JSON.parse(sessionStorage.getItem('currentDomain'));
    } catch (e) {

    }
    return currentDomainId;
  }

  getCurrentLoginUser() {
    var currentUser = "";
    try {
      currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    } catch (e) {

    }
    return currentUser;
  }

  getCurrentLoginAsUser() {
    var currentUser = "";
    try {
      currentUser = JSON.parse(sessionStorage.getItem('currentAsUser'));
    } catch (e) {

    }
    return currentUser;
  }

  getCurrentUserAccountType() {
    var currentUserAccountType = "";
    try {
      currentUserAccountType = JSON.parse(sessionStorage.getItem('currentUserAccountType'));
    } catch (e) {

    }
    return currentUserAccountType;
  }

  getCurrentCompanyCode() {
    var currentCompanyCode = "";
    try {
      currentCompanyCode = JSON.parse(sessionStorage.getItem('currentCompanyCode'));
    } catch (e) {

    }
    return currentCompanyCode;
  }

  getCurrentContactId() {
    var currentContactId = "";
    try {
      currentContactId = JSON.parse(sessionStorage.getItem('currentContactId'));
    } catch (e) {

    }
    return currentContactId;
  }

  getCurrentUserDn() {
    var currentUserDn = "";
    try {
      currentUserDn = JSON.parse(sessionStorage.getItem('currentUserDn'));
    }
    catch (e) {
    }
    return currentUserDn;
  };

  getCurrentUserPwd() {
    var currentUserPwd = "";
    try {
      currentUserPwd = JSON.parse(sessionStorage.getItem('currentUserPwd'));
    }
    catch (e) {
    }
    return currentUserPwd;
  };


  getCurrentDataRole() {
    var currentDataRole = "";
    try {
      currentDataRole = JSON.parse(sessionStorage.getItem('currentDataRole'));
    } catch (e) {

    }
    return currentDataRole;
  }

  getCurrentProcessRole() {
    var currentProcessRole = "";
    try {
      currentProcessRole = JSON.parse(sessionStorage.getItem('currentProcessRole'));
    } catch (e) {

    }
    return currentProcessRole;
  }

  getCurrentActionRole() {
    var currentActionRole = "";
    try {
      currentActionRole = JSON.parse(sessionStorage.getItem('currentActionRole'));
    } catch (e) {

    }
    return currentActionRole;
  }

  getCurrentNoOfExpiredDoc() {
    var currentNoOfExpiredDoc = 0;
    try {
      currentNoOfExpiredDoc = JSON.parse(sessionStorage.getItem('currentNoOfExpiredDoc'));
    } catch (e) {

    }
    return currentNoOfExpiredDoc;
  }

  getCurrentDateTime(daysToAdd?) {
    var utcDate = new Date();

    var currentDateTime = new Date(utcDate.getTime() + 28800 * 1000);

    if (daysToAdd == undefined || daysToAdd == null) {
      daysToAdd = 0;
    }

    currentDateTime.setDate(currentDateTime.getDate() + daysToAdd);

    return currentDateTime.toJSON();
  }

  getCurrentDate(daysToAdd?) {
    var utcDate = new Date();
    var currentDate = new Date(utcDate.getTime() + 28800 * 1000);

    if (daysToAdd == undefined || daysToAdd == null) {
      daysToAdd = 0;
    }

    currentDate.setDate(currentDate.getDate() + daysToAdd);
    return currentDate.toJSON().slice(0, 10);
  }

  convertCalendarDateToJson(inputDate?: Date) {
    var currentDateTime: Date;
    var returnDate: String = "";
    var utcDate = new Date();

    if (inputDate == null) {
      currentDateTime = new Date(utcDate.getTime() + 28800 * 1000);
      returnDate = currentDateTime.toJSON().slice(0, 10);
    } else {
      if (inputDate.toString().length > 10) {
        currentDateTime = new Date(inputDate.getTime() + 28800 * 1000);
        returnDate = currentDateTime.toJSON().slice(0, 10);

      } else {
        returnDate = inputDate.toString();
      }
    }

    return returnDate;

  }

  convertDateToString(inputDate?: Date, includeTime?: boolean) {
    var currentDate: Date;
    var returnDate: String = "";

    if (inputDate == null) {
      var utcDate = new Date();
      currentDate = new Date(utcDate.getTime() + 28800 * 1000);
    } else {
      currentDate = new Date(inputDate.getTime() + 28800 * 1000);
    }
    if (includeTime == null) {
      includeTime = true;
    } else {
      includeTime = includeTime;
    }


    var dd = currentDate.getDate();
    var mm = currentDate.getMonth() + 1; //because January is 0! 
    var yyyy = currentDate.getFullYear().toString();
    //Interpolation date
    returnDate = yyyy;
    returnDate = returnDate + ("00" + mm).substr(-2);
    returnDate = returnDate + ("00" + dd).substr(-2);

    if (includeTime) {
      var hh = currentDate.getHours();
      var min = currentDate.getMinutes();
      var ss = currentDate.getSeconds();
      returnDate = returnDate + "_";
      returnDate = returnDate + ("00" + hh).substr(-2);
      returnDate = returnDate + ("00" + min).substr(-2);
      returnDate = returnDate + ("00" + ss).substr(-2);
    }
    return returnDate;

  }

  convertStringToDate(dateString: string): Date | null {
    // Handle potential invalid formats
    if (!dateString) {
      return null;
    }

    // Attempt to parse the date string in various formats
    const dateFormats = [
      "YYYY-MM-DD", // ISO 8601 (e.g., "2023-12-25")
      "MM/DD/YYYY", // US format (e.g., "12/25/2023")
      "DD/MM/YYYY", // European format (e.g., "25/12/2023")
    ];

    for (const format of dateFormats) {
      const parts = dateString.split(/[-.\/]/);
      if (parts.length === 3) {
        let year, month, day;

        switch (format) {
          case "YYYY-MM-DD":
            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JavaScript
            day = parseInt(parts[2], 10);
            break;
          case "MM/DD/YYYY":
            month = parseInt(parts[0], 10) - 1;
            day = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
            break;
          case "DD/MM/YYYY":
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1;
            year = parseInt(parts[2], 10);
            break;
        }

        // Create a Date object and check for validity
        const date = new Date(year, month, day);
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
    }

    // If no format matches, return null
    return null;
  }

  converStringToDateTime(dateTimeString: string): Date | null {
    // Handle potential invalid formats
    if (!dateTimeString) {
      return null;
    }

    // Attempt to parse the date string in various formats
    const dateFormats = [
      "YYYY-MM-DDTHH:mm:ss.SSS", // ISO 8601 with milliseconds (e.g., "2023-12-25T12:30:00.123")
      "YYYY-MM-DDTHH:mm:ss", // ISO 8601 without milliseconds (e.g., "2023-12-25T12:30:00")
      "MM/DD/YYYY HH:mm:ss", // US format (e.g., "12/25/2023 12:30:00")
      "DD/MM/YYYY HH:mm:ss", // European format (e.g., "25/12/2023 12:30:00")
    ];

    for (const format of dateFormats) {
      const parts = dateTimeString.split(/[-.\/ T:]/);
      if (parts.length >= 6) {
        let year, month, day, hour, minute, second, millisecond;

        switch (format) {
          case "YYYY-MM-DDTHH:mm:ss.SSS":
            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JavaScript
            day = parseInt(parts[2], 10);
            hour = parseInt(parts[3], 10);
            minute = parseInt(parts[4], 10);
            second = parseInt(parts[5], 10);
            millisecond = parseInt(parts[6], 10);
            break;
          case "YYYY-MM-DDTHH:mm:ss":
            year = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1;
            day = parseInt(parts[2], 10);
            hour = parseInt(parts[3], 10);
            minute = parseInt(parts[4], 10);
            second = parseInt(parts[5], 10);
            millisecond = 0;
            break;
          case "MM/DD/YYYY HH:mm:ss":
            month = parseInt(parts[0], 10) - 1;
            day = parseInt(parts[1], 10);
            year = parseInt(parts[2], 10);
            hour = parseInt(parts[3], 10);
            minute = parseInt(parts[4], 10);
            second = parseInt(parts[5], 10);
            millisecond = 0;
            break;
          case "DD/MM/YYYY HH:mm:ss":
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1;
            year = parseInt(parts[2], 10);
            hour = parseInt(parts[3], 10);
            minute = parseInt(parts[4], 10);
            second = parseInt(parts[5], 10);
            millisecond = 0;
            break;
        }

        // Create a Date object and check for validity
        const date = new Date(year, month, day, hour, minute, second, millisecond);
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
    }

    // If no format matches, return null
    return null;
  }

  formatDateToDisplayString(inputDate?: string
    , includeTime?: boolean, includeSecond?: boolean
    , dateSeperator?: string, timeSeperator?: string) {
    var currentDate: Date;
    var returnDate: string = "";
    currentDate = this.converStringToDateTime(inputDate);


    if (inputDate == null) {
      var utcDate = new Date();
      currentDate = new Date(utcDate.getTime() + 28800 * 1000);
    } else {
      currentDate = new Date(currentDate.getTime());
    }
    if (includeTime == null) {
      includeTime = true;
    } else {
      includeTime = includeTime;
    }


    var dd = currentDate.getDate();
    var mm = currentDate.getMonth() + 1; //because January is 0! 
    var yyyy = currentDate.getFullYear().toString();
    //Interpolation date
    returnDate = yyyy;
    returnDate = returnDate + dateSeperator + ("00" + mm).substr(-2);
    returnDate = returnDate + dateSeperator + ("00" + dd).substr(-2);

    if (includeTime) {
      var hh = currentDate.getHours();
      var min = currentDate.getMinutes();
      var ss = currentDate.getSeconds();
      returnDate = returnDate + " ";
      returnDate = returnDate + ("00" + hh).substr(-2);
      returnDate = returnDate + timeSeperator + ("00" + min).substr(-2);
      if (includeSecond) {
        returnDate = returnDate + timeSeperator + ("00" + ss).substr(-2);
      }
    }
    return returnDate;

  }

  upper(inputText) {
    return inputText.toUpperCase();
  }

  convertYesNoToBoolean(inputYesNo) {

    var result;

    if (String(inputYesNo) === "Y" || String(inputYesNo) === "true") {
      result = true;
    }
    else if (String(inputYesNo) === "N" || String(inputYesNo) === "false") {
      result = false;
    }

    return result;
  }

  convertBooleanToYesNo(inputBoolean) {
    var result;


    if (String(inputBoolean) === "Y" || String(inputBoolean) === "true") {
      result = "Y";
    }
    else {
      result = "N";
    }
    return result;
  }

  convertDateTimetoDate(inputDate) {
    var result;

    if (inputDate != null) {
      result = inputDate.slice(0, 10);
    }
    else {
      result = null;
    }

    return result;
  }

  prepareAttachmentRecord(strModule: String, recordId: number, actualFileName: String, displayName: String) {
    var attachmentRec: any;

    attachmentRec.Module = strModule;
    attachmentRec.RecordKey = recordId;
    attachmentRec.ActualFileName = actualFileName;
    attachmentRec.DisplayName = displayName;
    attachmentRec.CreateDate = new Date();
    attachmentRec.UpdateUser = this.getCurrentLoginUser();
    attachmentRec.UpdateDate = new Date();

    return attachmentRec;

  }

  getDataTableHeight(rowCount: number) {
    var result: string;

    if (window.innerHeight - 300 - 18 * rowCount > 0) {
      result = window.innerHeight - 300 - 18 * rowCount + "px";
    } else {
      result = "30vh";
    }
    result = "30vh";
    return result;
  }

  getDataTableWidth() {
    var result: string;

    if (window.innerWidth - 260 > 0) {
      result = window.innerWidth - 260 + "px";
    } else {
      result = "75vw";
    }
    return result;
  }

  //20211005 Enhancement Start - Update Date Field to DateTime Field
  getCurrentUTCDateTime(daysToAdd?) {
    var utcDate = new Date();

    var currentDateTime = new Date(utcDate.getTime());

    if (daysToAdd == undefined || daysToAdd == null) {
      daysToAdd = 0;
    }

    currentDateTime.setDate(currentDateTime.getDate() + daysToAdd);

    return currentDateTime.toJSON();
  }

  convertCalendarDateTimeToJson(inputDate?: Date) {
    var currentDateTime: Date;
    var returnDate: String = "";
    var utcDate = new Date();

    if (inputDate == null) {
      currentDateTime = new Date(utcDate.getTime() + 28800 * 1000);
      returnDate = currentDateTime.toJSON();
    } else {
      if (inputDate.toString().length > 10) {
        currentDateTime = new Date(inputDate.getTime() + 28800 * 1000);
        returnDate = currentDateTime.toJSON();

      } else {
        returnDate = inputDate.toString();
      }
    }

    return returnDate;

  }
  //20211005 Enhancement End

  get1900Date() {
    return "1900-01-01";
  }


  sortListByLabel(inputList: IDropdownList[]) {
    var result: IDropdownList[];
    result = inputList.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    return result;
  }

  sortListByValue(inputList: IDropdownList[]) {
    var result: IDropdownList[];
    result = inputList.sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    return result;
  }

  sortListByDesc02(inputList: IDropdownList[]) {
    var result: IDropdownList[];
    result = inputList.sort((a, b) => (a.desc02 > b.desc02) ? 1 : ((b.desc02 > a.desc02) ? -1 : 0));
    return result;
  }

  roundToDP(inputNumber, dp) {
    var multiplier = 1;
    for (var i = 1; i <= dp; i++) {
      multiplier = multiplier * 10;
    }

    return Math.round(inputNumber * multiplier) / multiplier;
  }

  roundToPercentDP(inputNumber, dp) {
    var multiplier = 1;
    for (var i = 1; i <= dp; i++) {
      multiplier = multiplier * 10;
    }

    return Math.round(inputNumber * 100 * multiplier) / multiplier;
  }

  blankToZero(input) {
    var result = input;
    if (input == null || input == undefined || input == " ") {
      result = 0;
    }
    return result;
  }


  async encryptText(input) {
    var encryptString = "";
    if (input == undefined ||
      input == null || input == "" || input == " ") {
      encryptString = "";
    } else {
      encryptString = await this.http.get(this.LoginApiPath + "encrypt/" + input,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json"
          })
        })
        .map((response: any) => response).toPromise();
    }
    return encryptString;
  }

}


interface IDropdownList {
  value?;
  label?; //this is desc01
  desc02?;
}
